import { render, staticRenderFns } from "./BreadcrumbsBar.vue?vue&type=template&id=78042dea&scoped=true&"
import script from "./BreadcrumbsBar.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbsBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78042dea",
  null
  
)

export default component.exports